import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "auth_token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch (err) {
    console.warn("[api] getToken failed:", err);
    return "";
  }
}

export function setToken(t) {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (err) {
    console.warn("[api] setToken failed:", err);
  }
}

export const api = axios.create({
  baseURL: API,
});

// Attach Bearer token on every request
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler — clear token and bounce to /login
let redirecting = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const path = error?.config?.url || "";
    if (status === 401 && !path.includes("/auth/me") && !path.includes("/auth/login")) {
      setToken("");
      if (!redirecting && typeof window !== "undefined" && window.location.pathname !== "/login") {
        redirecting = true;
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function currency(n) {
  const value = Number(n || 0);
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
